import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { DepartmentService } from '../../services/department.service';
import { EmployeeService } from '../../services/employee.service';
import { toast } from 'angular2-materialize';

@Component({
    selector: 'app-update-department',
    templateUrl: './update-department.component.html',
    styleUrls: ['./update-department.component.css', '../../app.component.css']
})

export class UpdateDepartmentComponent implements OnInit, OnDestroy {

    departmentForm: FormGroup;
    department: any = [];

    responsibles = {};
    responsibleInit: any;
    responsibleText = '';

    id: string;

    applyInPrompterReportVal = false;
    applyInSupervisorReportVal = false;
    applyInCheckClockVal = false;
    applySecurityReportVal = false;

    gdSubs: any;
    igeSubs: any;
    geSubs: any;

    constructor(private formBuilder: FormBuilder,
                private router: Router,
                private activatedRoute: ActivatedRoute,
                private departmentService: DepartmentService,
                private employeeService: EmployeeService) {
        this.loadResponsibles();

        this.activatedRoute.params.subscribe(parameters => {
            this.id = parameters['id'];

            this.gdSubs = this.departmentService.getDepartment(this.id).subscribe(departmentObj => {
                this.gdSubs.unsubscribe();

                this.department = departmentObj;

                if (this.department.responsibleId) {
                    this.igeSubs = this.employeeService.getEmployee(this.department.responsibleId).subscribe(responsibleObj => {
                        this.igeSubs.unsubscribe();
                        if(responsibleObj.active != 1) return toast('El empleado responsable fue borrado de la base de datos.', 5000);
                        this.responsibleText = responsibleObj.name + ' ' + responsibleObj.lastName + ' ' + '(' + responsibleObj.internalKey + ')';
                    });
                }

                if (this.department.applyInPrompterReport !== undefined) {
                    this.applyInPrompterReportVal = this.department.applyInPrompterReport;
                }
                if (this.department.applyInSupervisorReport !== undefined) {
                    this.applyInSupervisorReportVal = this.department.applyInSupervisorReport;
                }
                if (this.department.applyInCheckClock !== undefined) {
                    this.applyInCheckClockVal = this.department.applyInCheckClock;
                }
                this.applySecurityReportVal = !!this.department.applySecurityReport;
            });

            
        });
    }

    ngOnInit() {
        this.departmentForm = this.formBuilder.group({
            name: ['', Validators.required],
            comments: '',
            responsible: '',
            applyInPrompterReport: '',
            applyInSupervisorReport: '',
            applyInCheckClock: '',
            applySecurityReport: '',
        });
    }

    onSubmitDepartment() {
        this.department = this.saveDepartment();

        this.departmentService.putDepartment(this.department, this.id).then(res => {
            this.router.navigate(['/departments']);
        });
    }

    saveDepartment() {
        let responsibleId = '';
        if (this.departmentForm.get('responsible').value) {
            responsibleId = this.responsibles[this.departmentForm.get('responsible').value];
        }

        const departmentJson = {
            applyInCheckClock: this.departmentForm.get('applyInCheckClock').value,
            applyInPrompterReport: this.departmentForm.get('applyInPrompterReport').value,
            applyInSupervisorReport: this.departmentForm.get('applyInSupervisorReport').value,
            applySecurityReport: this.departmentForm.get('applySecurityReport').value,
            comments: this.departmentForm.get('comments').value,
            name: this.departmentForm.get('name').value,
            responsibleId:  responsibleId,
            updatedAt: new Date()
        };

        return departmentJson;
    }

    loadResponsibles() {
        this.geSubs = this.employeeService.getEmployees().subscribe(tempEmployees => {
            const dataEmployee = {};

            for (const idx in tempEmployees) {
                let employeeDisplayValue = `${tempEmployees[idx].name} ${tempEmployees[idx].lastName} (${tempEmployees[idx].internalKey})`;
                dataEmployee[employeeDisplayValue] = null;
                this.responsibles[employeeDisplayValue] = tempEmployees[idx].id$;
            }

            this.responsibleInit = {
                'data': dataEmployee,
                onAutocomplete: (val) => { // console.log(val); // console.log(this.responsibles[val]);
                }
            };
        });
    }

    onBlurResponsible() {
        if (this.responsibles[this.responsibleText] === undefined) {
            this.responsibleText = '';
        }
    }

    ngOnDestroy() {
        this.geSubs.unsubscribe();
    }

}
